/**
 * DashboardExportButton.jsx
 *
 * Self-contained Export PDF button for the Dashboard.
 * Calls exportDashboardPDF() from the sibling service file.
 * Handles loading state, error toast, and disables during generation.
 */

import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { exportDashboardPDF } from '../services/exportDashboardPdf';

const DashboardExportButton = ({ data, disabled }) => {
    const [exporting, setExporting] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    const handleExport = () => {
        if (exporting || disabled) return;
        setErrorMsg(null);

        exportDashboardPDF({
            data,
            onStart: () => setExporting(true),
            onSuccess: () => {
                // Success – nothing extra to show; file download triggers automatically
            },
            onError: (msg) => {
                setErrorMsg(msg);
                // Auto-clear error after 4 s
                setTimeout(() => setErrorMsg(null), 4000);
            },
            onFinish: () => setExporting(false),
        });
    };

    return (
        <>
            <button
                className={`db-action-btn db-btn-primary db-export-pdf-btn${exporting ? ' db-export-loading' : ''}${disabled ? ' db-export-disabled' : ''}`}
                onClick={handleExport}
                disabled={disabled || exporting}
                title="Export dashboard as PDF"
            >
                {exporting ? (
                    <>
                        <Loader2 size={14} className="db-export-spinner" />
                        <span>Generating…</span>
                    </>
                ) : (
                    <>
                        <Download size={14} />
                        <span>Export PDF</span>
                    </>
                )}
            </button>

            {/* Inline error toast */}
            {errorMsg && (
                <div className="db-export-error-toast">
                    ⚠ {errorMsg}
                </div>
            )}
        </>
    );
};

export default DashboardExportButton;
